import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Sidebar } from 'primeng/primeng';
import { SelectItem } from 'primeng/components/common/selectitem';

import { StrtPriority } from '../../../../shared/models/plan/StrtPriority';
import { TagService } from '../../../services/tag.service';


@Component({
  selector: 'app-priority',
  templateUrl: './priority.component.html',
  styleUrls: ['./priority.component.scss']
})
export class PriorityComponent implements OnInit {
  readonly MAX_TITLE_LENGTH = 25;
  readonly MAX_DESCRIPTION_LENGTH = 200;

  @Output() create = new EventEmitter<StrtPriority>();
  @Output() createError = new EventEmitter<Error>();
  @Output() edit = new EventEmitter<StrtPriority>();
  @Output() editError = new EventEmitter<Error>();
  @Output() cancel = new EventEmitter<void>();

  private _priorityForm: FormGroup;
  private _isActive = false;
  private isEdit = false;
  private priorityId: number;

  tagSelectItems: SelectItem[] = [{label: 'Select a Tag', value: undefined}];

  constructor(private formBuilder: FormBuilder, private tagService: TagService) { }

  ngOnInit() {
    this.tagService.getSQFTags().subscribe(it => {
      this.tagSelectItems.push(...this.tagService.getTagSelectItems(it));
    });
    this.createForm();
  }

  editPriority(priority: StrtPriority) {
    this._isActive = true;
    this.isEdit = true;
    this.priorityId = priority.priorityId;
    this.priorityForm.patchValue({
      title: priority.title,
      description: priority.description,
      tag: priority.tagId
    });
  }

  createPriority() {
    this._isActive = true;
    this.isEdit = false;
    this.priorityId = undefined;
  }

  get priorityForm() {
    return this._priorityForm;
  }

  get title() {
    return this.priorityForm.get('title');
  }

  get description() {
    return this.priorityForm.get('description');
  }

  get tag() {
    return this.priorityForm.get('tag');
  }

  get headerContent() {
    return this.isEdit ? 'Edit Priority Statement' : 'Add Priority Statement';
  }

  get isSubmitDisabled() {
    return !(this.priorityForm.status === 'VALID' &&
      !this.priorityForm.pristine &&
      this.priorityForm.dirty);
  }

  get descriptionRemainingCharacters() {
    return this.MAX_DESCRIPTION_LENGTH - this.description.value.length;
  }

  get titleRemainingCharacters() {
    return this.MAX_TITLE_LENGTH - this.title.value.length;
  }

  get isActive() {
    return this._isActive;
  }

  set isActive(isActive) {
    this._isActive = isActive;
  }

  onShowSidebar(sidebar: Sidebar) {
    sidebar.maskClickListener();
  }

  onHideSidebar() {
    this.priorityForm.reset({title: '', description: '', tag: undefined});
    this.isEdit = false;
    this.priorityId = undefined;
  }

  onSubmit() {
    const priority = this.prepareSavePriority();
    if (this.isEdit) {
      this.edit.emit(priority);
    } else {
      this.create.emit(priority);
    }
  }

  private createForm() {
    this._priorityForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(this.MAX_TITLE_LENGTH)]],
      description: ['', [Validators.required, Validators.maxLength(this.MAX_DESCRIPTION_LENGTH)]],
      tag: ['', Validators.required]
    });
  }

  private prepareSavePriority(): StrtPriority {
    return {
      priorityId: this.priorityId,
      title: this.title.value,
      description: this.description.value,
      tagId: this.tag.value,
      objectives: []
    };
  }
}
